import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowInstanceId} from "common/flowmaster/types/workflow";

export type WorkflowInstanceUpdateDefaultAssetNameAction = {
  type: WorkflowsActionTypes["WORKFLOW_INSTANCE_UPDATE_DEFAULT_ASSET_NAME"]["SUCCESS"];
  payload: {
    workflow_instance_id: WorkflowInstanceId;
    default_asset_name: string;
  };
};

export default function updateWorkflowInstanceDefaultAssetName(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_INSTANCE_UPDATE_DEFAULT_ASSET_NAME,
    (
      organisationId: OrganisationId,
      configId: WorkflowInstanceId,
      defaultAssetName: string,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/workflow_instance/${configId}/default_asset_name`,
          {
            default_asset_name: defaultAssetName,
          },
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
